import { defineMessages } from 'react-intl'

const cartPanelMessages = defineMessages({
  title: {
    id: 'mWxW_Nn70-ovpCDsK2FG',
    defaultMessage: 'Review cart',
    description: 'Heading displayed at the top of the trip planner cart review panel',
  },
})

export default cartPanelMessages
